exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-2427d626],video[data-v-2427d626]{max-height:50px}.no-select[data-v-2427d626]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.sortable-ghost[data-v-2427d626]{opacity:.1}", ""]);

// exports
